module.exports = __webpack_public_path__ + "static/img/ubg4.a6244dfb.png";